// im warenkorb gibt es manchmal auch crossselling (zubehoer) produkte, die im phone als slider angezeigt werden

import Splide from '@splidejs/splide';

export class CrossSellingSlider {
    private accessoriesSliders: NodeListOf<Element>;

    constructor() {
        this.accessoriesSliders = document.querySelectorAll('#accessoriesSlider.splide');
        if (this.accessoriesSliders.length > 0) {
            this.initializeSliders();
        }
    }

    private initializeSliders(): void {
        this.accessoriesSliders.forEach((sliderElement) => {
            new Splide(sliderElement as HTMLElement, {
                type: 'slide',
                perPage: 3,
                perMove: 1,
                gap: 30,
                rewind: false,
                width: '100%',
                pagination: false,
                arrows: true,
                fixedHeight: '480px',
                padding: { left: 20, right: 20 },
                classes: {
                    arrows: 'tns-controls',
                    prev: 'splide__arrow--prev controls-prev prev',
                    next: 'splide__arrow--next controls-next next',
                },
                breakpoints: {
                    559: {
                        perPage: 1,
                        perMove: 1,
                    },
                    767: {
                        perPage: 2,
                        perMove: 2,
                    },
                },
            }).mount();
        });
    }
}

